import { mindFetch } from './api';
import { API_BASE } from './config';
/** Persist the bundled insight first, so indexing has a durable, organization-owned source. */
export async function storeKeyInsight(sessionId, text) {
  const created = await mindFetch(`${API_BASE}/summaries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: sessionId,
      summary_text: text,
      summary_type: 'key_insight',
    }),
  });
  if (!created.ok) throw new Error('Unable to save insight');
  const { summaryId } = await created.json();
  const indexed = await mindFetch(`${API_BASE}/vectors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'store', vector_id: summaryId }),
  });
  if (!indexed.ok) throw new Error('Unable to index insight');
  const updated = await mindFetch(`${API_BASE}/summaries/${summaryId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_vectorized: true }),
  });
  if (!updated.ok) throw new Error('Unable to mark indexed insight');
  return indexed;
}
